import {FC, PropsWithChildren} from "react"
import {ReactSVG} from "react-svg"

import dislikeIcon from "@frontend/design/icons/dislike.svg"
import likeIcon from "@frontend/design/icons/like.svg"
import {useTranslation} from "@frontend/i18n"
import {widgetChrome} from "@frontend/widget/brandChrome"
import {css, cx} from "@styled-system/css"
import {iconsColor, vstack} from "@styled-system/patterns"

import {On} from "./types"
import {Modal} from "../modal"

export interface Props {
  onSubmitted: () => void
  onClose: () => void
  on?: On
}

export const ModalContainer: FC<PropsWithChildren<Props>> = ({
  children,
  onClose,
  on,
}) => {
  const t = useTranslation()

  const feedbackRatingTitle =
    on?.feedback?.rating === "NEGATIVE"
      ? t(`feedback.general.NEGATIVE.title`)
      : t(`feedback.general.POSITIVE.title`)

  return (
    <Modal
      title={
        on ? feedbackRatingTitle : t("feedback.general.feedbackModalTitle")
      }
      show
      message={t("feedback.general.feedbackModal", {
        productTitle: widgetChrome.productTitle,
      })}
      onDismiss={onClose}
      width={610}
      containerCss={css.raw({
        paddingBottom: 16,
      })}
      icon={
        <div
          className={vstack({
            borderRadius: 8,
            backgroundColor: on
              ? on.feedback.rating === "POSITIVE"
                ? "bgGreen"
                : "bgRed"
              : "background.brand.primarySubtle",
            width: 36,
            height: 36,
            justifyContent: "center",
          })}
        >
          <ReactSVG
            src={
              on && on.feedback.rating === "NEGATIVE" ? dislikeIcon : likeIcon
            }
            className={cx(
              iconsColor({
                color: on
                  ? on.feedback.rating === "POSITIVE"
                    ? "green"
                    : "red"
                  : "foreground.brand.primary",
              }),
            )}
          />
        </div>
      }
    >
      {children}
    </Modal>
  )
}
